import { indexTransactionsOperation } from "@api/services/transactions"

const listProjectTransactions = async (request, projectId) => {
  // TODO: Might need to consider pagination here to pull all project transactions.
  const { data: projectTransactions } = await request(indexTransactionsOperation, { projectId })

  return projectTransactions
}

export default listProjectTransactions
